import * as React from 'react'
import { ImageModal } from '#app/components/image-modal.tsx'

const files = [
	'10.jpeg',
	'11.jpeg',
	'12.jpeg',
	'13.jpeg',
	'15.jpeg',
	'16.jpeg',
	'17.jpeg',
	'18.jpeg',
	'19.jpeg',
	'2.jpeg',
	'20.jpeg',
	'22.jpeg',
	'23.jpeg',
	'24.jpeg',
	'25.jpeg',
	'27.jpeg',
	'28.jpeg',
	'30.jpeg',
	'31.jpeg',
	'33.jpeg',
	'34.jpeg',
	'35.jpeg',
	'37.jpeg',
	'38.jpeg',
	'39.jpeg',
	'4.jpeg',
	'40.jpeg',
	'41.jpeg',
	'42.jpeg',
	'44.jpeg',
	'46.jpeg',
	'47.jpeg',
	'48.jpeg',
	'49.jpeg',
	'50.jpeg',
	'51.jpeg',
	'52.jpeg',
	'54.jpeg',
	'55.jpeg',
	'56.jpeg',
	'57.jpeg',
	'58.jpeg',
	'59.jpeg',
	'6.jpeg',
	'60.jpeg',
	'61.jpeg',
	'62.jpeg',
	'63.jpeg',
	'64.jpeg',
	'65.jpeg',
	'66.jpeg',
	'67.jpeg',
	'7.jpeg',
	'8.jpeg',
]

export function Showcase() {
	const [open, setOpen] = React.useState<string | null>()

	return (
		<section className="relative bg-[#000]">
			<div className="faded-bg absolute h-40 w-full" />
      <div className='h-6' />
			<div className="grid grid-cols-2 px-4 md:grid-cols-4">
				{files.map(image => (
					<div key={image}>
						<img
							onClick={() => setOpen(`/img/showcase/${image}`)}
							width="800px"
							height="600px"
							loading="lazy"
              className="hover:cursor-pointer hover:scale-105 transition duration-200 ease-in-out transform"
							data-src={`/img/showcase/${image}`}
							alt="random showcase the swapping of the faces"
							src={`/img/showcase/${image}`}
						/>
					</div>
				))}
			</div>
			<div className="faded-bg-inverse absolute bottom-0 h-40 w-full" />
			{open && <ImageModal src={open} onClose={() => setOpen(null)} />}
		</section>
	)
}
